import {get} from "./HttpClient"
import {API_GET_SEARCHED_AIRPORTS, API_GET_SEARCHED_AIRPORTS_CODES} from "./ApisRoutes";

export const GetAirportsService = (search, locale) => {
    // Encoded: a search term containing & or # used to truncate the query
    // string and send a malformed request.
    const airportsApi = `${API_GET_SEARCHED_AIRPORTS}?Search=${encodeURIComponent(
        search ?? ""
    )}&Locale=${encodeURIComponent(locale ?? "")}`;
    return new Promise((resolve, reject) => {
        get(airportsApi).then(response => {
            resolve(response?.data);
        }).catch(error => {
            console.error(error);
            reject(error);
        });
    });
}

export const GetAirportsCodesService = (search, locale, IataOrName = 'iata') => {
    const airportsApi = `${API_GET_SEARCHED_AIRPORTS_CODES}?Search=${encodeURIComponent(
        search ?? ""
    )}&Locale=${encodeURIComponent(locale ?? "")}&IataOrName=${encodeURIComponent(IataOrName)}`;
    return new Promise((resolve, reject) => {
        get(airportsApi)
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                console.error(error);
                reject(error);
            });
    });
};
